export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/ES-e234ca57cb39ebee8522dd6171f53f57.png";